import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { t } from '~/components/I18n';
import {
  useLandHistoryParams,
  useLandHistorySummary,
} from '~/components/Land/History/LandHistory.hooks';
import { Tabs } from '~/components/Tab/Tabs';
import tabsStyles from '~/components/Tab/Tabs.module.scss';
import styles from './LandHistoryTabs.module.scss';
export type LandHistoryTabsProps = {
  className?: string;
};
export const LandHistoryTabs = ({ className }: LandHistoryTabsProps) => {
  const { category } = useLandHistoryParams();
  const {
    data: { counts },
  } = useLandHistorySummary();
  return (
    <Tabs variant="underline" className={classNames(styles.root, className)}>
      <li>
        <Link
          to={{ search: '?category=ALL', state: { scroll: 'restore' } }}
          className={classNames({ [tabsStyles.active]: category === 'ALL' })}
          replace>
          {t('citizen_don_all_history')} {counts['all'] > 0 && counts['all']}
        </Link>
      </li>
      <li>
        <Link
          to={{ search: '?category=ONGOING', state: { scroll: 'restore' } }}
          className={classNames({ [tabsStyles.active]: category === 'ONGOING' })}
          replace>
          {t('citizen_land_myhistory_category_ongoing')}{' '}
          {counts['ongoing'] > 0 && counts['ongoing']}
        </Link>
      </li>
      <li>
        <Link
          to={{ search: '?category=WINS', state: { scroll: 'restore' } }}
          className={classNames({ [tabsStyles.active]: category === 'WINS' })}
          replace>
          {t('citizen_land_myhistory_category_win')} {counts['wins'] > 0 && counts['wins']}
        </Link>
      </li>
      <li>
        <Link
          to={{ search: '?category=NOT_WINS', state: { scroll: 'restore' } }}
          className={classNames({ [tabsStyles.active]: category === 'NOT_WINS' })}
          replace>
          {t('citizen_land_myhistory_category_notwin')} {counts['notWins'] > 0 && counts['notWins']}
        </Link>
      </li>
    </Tabs>
  );
};
